import { SET_SPLASH_SCREEN_VISIBLE, SET_LOGOUT_TOAST } from "./actionsTypes";

export default function reducer(state, action) {
  switch (action.type) {
    case SET_SPLASH_SCREEN_VISIBLE:
      return {
        ...state,
        adProductSplashScreen: {
          seen: !action.payload,
          visible: action.payload,
        },
      };
    case SET_LOGOUT_TOAST:
      return {
        ...state,
        toasts: {
          ...state.toasts,
          logout: action.payload,
        },
      };
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
}
